import { Component, Input } from "@angular/core";

import { PlanningActivity } from "../../../shared/types";

@Component({
	selector: "ic-activity-list",
	templateUrl: "./activity-list.component.html",
	styleUrls: ["./activity-list.component.scss"],
	standalone: false,
})
export class ActivityListComponent {
	// @ts-expect-error TS2564
	@Input() activities: PlanningActivity[];
}
